// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2349":"491bc192","2577":"bd32c84f"}[chunkId] + ".chunk.css";
};